// extracted by mini-css-extract-plugin
module.exports = {"textarea":"Textarea_textarea__22979","label":"Textarea_label__2vH1u"};